import { GetState, SetState, State, StoreApi } from 'zustand';
import { NavigationSlice } from './navigation/NavigationSlice';
import { SettingsSlice } from './settings/SettingsSlice';
import { UserSlice } from './user/UserSlice';
import { QuestionAnswersSlice } from '~/training/state/question/saveQuestionAnswers';
import { ChatBotSlice } from '~/training/state/chatBot/ChatBotSlice';
import { PretestSlice } from './pretest/PretestSlice';

export type TrainingState = SettingsSlice &
  UserSlice &
  NavigationSlice &
  QuestionAnswersSlice &
  ChatBotSlice &
  PretestSlice;

export type SliceCreator<T extends State> = (
  set: SetState<T>,
  get: GetState<TrainingState>,
  api: StoreApi<TrainingState>
) => T;
